import { down } from 'styled-breakpoints';
import styled from 'styled-components';

export const MenuTreeWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

export const NodeTreeScrollContainer = styled.div`
    margin: 20px;
    margin-top: 12px;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    grid-row-gap: 5px;
    row-gap: 5px;
    position: absolute;
    top: 0;
    bottom: 12px;
    left: 0;
    right: -10px;

    overflow-y: auto;
    overflow-x: hidden;

    .ant-tree {
        .ant-tree-treenode {
            margin-bottom: 4px;
        }
        .ant-tree-treenode-selected {
            &.first-level.empty-children {
                .ant-tree-node-content-wrapper {
                    background-color: #23a457;
                    color: ${({ theme }) => theme.palette.common.white};
                }
            }

            .ant-tree-node-content-wrapper {
                background-color: transparent;
                color: #23a457;
            }

            &.parent-node-with-content {
                background: #23a457;
                color: ${({ theme }) => theme.palette.common.white};
            }
            &.not-empty-children {
                .ant-tree-node-content-wrapper {
                    background: #23a457;
                    color: ${({ theme }) =>
                        theme.palette.common.white} !important;
                }
            }
        }

        .parent-nodes {
            background: #23a457;
            margin-bottom: 4px;

            color: ${({ theme }) => theme.palette.common.white};
            border-radius: ${({ theme }) => theme.borderRadius.medium};

            .ant-tree-node-content-wrapper:hover {
                background-color: transparent;
            }

            &.first-level.not-empty-children {
                .ant-tree-node-content-wrapper {
                    pointer-events: none;
                }
            }
        }
    }

    .ant-tree {
        .ant-tree-treenode {
            margin-left: 8px;
            margin-right: 12px;

            font-size: 21px;
            transition: all 300ms;
            padding: 0;
            border-radius: ${({ theme }) => theme.borderRadius.medium};

            .ant-tree-node-content-wrapper {
                display: flex;
                border-radius: ${({ theme }) => theme.borderRadius.medium};
            }
            .ant-tree-node-content-wrapper.ant-tree-node-selected {
                border-radius: ${({ theme }) => theme.borderRadius.medium};
            }

            .ant-tree-switcher-leaf-line {
                display: none;
            }
            .ant-tree-switcher {
                background: transparent;
            }
            .ant-tree-indent-unit {
                &:before {
                    z-index: -1;
                }
            }

            .icons {
                svg {
                    width: 28px;
                    height: 28px;
                    padding: 3px;
                }
            }

            .ant-tree-iconEle {
                svg path {
                    &[stroke] {
                        stroke: currentColor;
                    }
                    &[fill] {
                        fill: currentColor;
                    }
                }
            }

            .ant-tree-node-content-wrapper > .ant-tree-title {
                padding: 15px;
                ${down('lg')} {
                    padding: 8px;
                }
            }

            .ant-tree-title {
                position: relative;
                flex: 1;
                .title-nowrap {
                    position: absolute;
                    white-space: nowrap;
                    overflow: hidden;
                    left: 0;
                    right: 0;
                    text-overflow: ellipsis;
                }
            }

            &.indexed {
                .ant-tree-iconEle {
                    color: #f50;
                }
            }
            span {
                flex-shrink: 0;
            }
            .ant-tree-draggable-icon {
                display: none;
            }
            .site-tree-search-value {
                color: #f50;
            }

            ${down('lg')} {
                font-size: 16px;
            }
        }

        .ant-tree-switcher {
            display: flex;
            align-items: center;
            order: 3;
            margin-right: 12px;
            svg {
                path {
                    &[stroke] {
                        stroke: currentColor;
                    }
                    &[fill] {
                        fill: currentColor;
                    }
                }
            }

            :empty {
                display: none;
            }
        }

        /* .ant-tree-node-selected {
            background: #23a457 !important;
            color: ${({ theme }) => theme.palette.common.white};
            border-radius: ${({ theme }) => theme.borderRadius.medium};
        } */
        // .alone-leaf,
    }
`;
